module.exports = __webpack_public_path__ + "img/BackgroundInitial1.64407cec.png";